import React, { Component, PropTypes } from 'react'
import { render } from 'react-dom'
import { getCookie, ajaxPost, createUrl } from '../../common/utils'
import { ONECLOUD_API_HOST } from '../../common/consts'

export default class Buy extends Component {
	constructor(props) {
        super(props)
    }

    buy = () => {
        if (!this.checkLogin()) return this.jumpToLogin()
        ajaxPost(
            `${ONECLOUD_API_HOST}/tqcode/query`,
            { phone: getCookie('phone'), channel: 1 },  // channel=1 福建电信
            (res) => {
                // test
                // res = {iRet: 633, sMsg: '--msg', data: {
                //     status: 2
                // }}

                const statusPop = {
                    '0': 'unused',
                    '1': 'used',
                    '2': 'overdue'
                }
                switch(+res.iRet) {
                    case 0:
                        this.props.updatePopData({pop: statusPop[res.data.status]})
                        return
                    case 30200:
                        this.props.updatePopData({pop: 'noPriority'})
                        return
                    case -501:
                        this.jumpToLogin()
                        return
                    default:
                        this.props.popTip(res.sMsg)
                }
            },
            () => {
                this.props.popTip('网络繁忙，请稍后再试（s）')
            }
        )
    }

    checkLogin() {
        return getCookie('phone') && window.siteHasLogined ? true: false
    }

    jumpToLogin() {
        location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(location.href)}`
    }

	render() {
        const { type } = this.props

		return (
            <div>
            {
                type === 'pcBtn1' &&
                <a className="btn flipInX animated">
                    <span>活动已结束</span>
                </a>
            }
            {
                type === 'pcBtn2' &&
                <a className="btn">
                    <span>活动已结束</span>
                </a>
            }
            {
                type === 'mbBtn1' &&
                <a className="hd_btn btn_style">活动已结束</a>
            }
            {
                type === 'mbBtn2' &&
                <a className="section_btn btn_style">活动已结束</a>
            }
            {
                type === 'mbBtn3' &&
                <a className="btn_style">活动已结束</a>
            }
            </div>
		)
	}
}

export const TipPop = (props) => {
    const { msg, btn, url, onBtn, onClose} = props
    let _onBtn = onBtn ? onBtn : onClose

    return <div className="act_pop">
            <div className="pop_wp">
                <a href="javascript:;" className="pop_close" title="关闭" onClick={onClose}>关闭</a>
                <h4 className="pop_tit" dangerouslySetInnerHTML={{__html: msg}}></h4>
                <a href={url} className="pop_btn" onClick={_onBtn}>{btn}</a>
            </div>
        </div>
}

TipPop.propTypes = {
    msg: PropTypes.string.isRequired,
    btn: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
}

TipPop.defaultProps = {
    url: 'javascript:;'
}


// WEBPACK FOOTER //
// ./js/src/pages/FjUpSpeed_pc/Components.js